<div class="emoji-editor">
  <div class="emoji-editor__header">
    <h3 class="emoji-editor__header-title">Emojis</h3>
    <button type="button" class="emoji-editor__close-btn" (click)="onClose()" aria-label="Close">&times;</button>
  </div>
  <div class="emoji-editor__body">
    <!-- Error loading emoji list from API -->
    <div class="emoji-editor__section" *ngIf="emojiError()">
      <p class="emoji-editor__error-text">{{ emojiError() }}</p>
    </div>
    <!-- Search (Gboard-style: type "happy", "love", "fire", etc.) -->
    <div class="emoji-editor__section">
      <label class="emoji-editor__label" for="emoji-search">Search emoji</label>
      <input
        id="emoji-search"
        type="text"
        class="emoji-editor__search"
        [ngModel]="searchQuery()"
        (ngModelChange)="searchQuery.set($event)"
        placeholder="e.g. happy, love, fire, food"
        aria-label="Search emoji by keyword"
      />
    </div>
    <!-- Emoji grid in a scrollable container -->
    <div class="emoji-editor__section">
      <label class="emoji-editor__label">Select emoji</label>
      <div class="emoji-editor__scroll-wrap">
        <p class="emoji-editor__loading" *ngIf="emojiLoading()">Loading…</p>
        <div class="emoji-editor__grid" *ngIf="!emojiLoading()">
          <button
            type="button"
            *ngFor="let emoji of filteredEmojiList(); trackBy: emojiTrackBy"
            class="emoji-editor__emoji-btn"
            [class.emoji-editor__emoji-btn--selected]="selectedEmoji() === emoji"
            (click)="selectEmoji(emoji)"
            [attr.aria-label]="'Select emoji ' + emoji"
          >
            <span class="emoji-editor__emoji-char">{{ emoji }}</span>
          </button>
        </div>
      </div>
    </div>

    <!-- In / Out (edit mode only) -->
    <div class="emoji-editor__section" *ngIf="isEditMode">
      <label class="emoji-editor__label">In</label>
      <div class="emoji-editor__time-row">
        <div class="emoji-editor__time-input-wrap">
          <input
            type="text"
            class="emoji-editor__time-input"
            [value]="inTimecode"
            (blur)="onInTimeBlur($event)"
            placeholder="00:00:00.000"
          />
          <button
            type="button"
            class="emoji-editor__time-now-btn"
            title="Set to current playhead time"
            (click)="setInToPlayhead()"
            aria-label="Set In to playhead"
          >
            Now
          </button>
        </div>
      </div>
      <label class="emoji-editor__label">Out</label>
      <div class="emoji-editor__time-row">
        <div class="emoji-editor__time-input-wrap">
          <input
            type="text"
            class="emoji-editor__time-input"
            [value]="outTimecode"
            (blur)="onOutTimeBlur($event)"
            placeholder="00:00:00.000"
          />
          <button
            type="button"
            class="emoji-editor__time-now-btn"
            title="Set to current playhead time"
            (click)="setOutToPlayhead()"
            aria-label="Set Out to playhead"
          >
            Now
          </button>
        </div>
      </div>
    </div>

    <!-- Scale (0.1 - 3.0) -->
    <div class="emoji-editor__section">
      <label class="emoji-editor__label">Scale</label>
      <div class="emoji-editor__scale-row">
        <input
          type="range"
          class="emoji-editor__slider"
          [min]="scaleMin"
          [max]="scaleMax"
          [step]="scaleStep"
          [value]="scale"
          (input)="onScaleChange(($any($event.target).value))"
        />
        <input
          type="number"
          class="emoji-editor__number"
          [min]="scaleMin"
          [max]="scaleMax"
          [step]="scaleStep"
          [ngModel]="scale"
          (ngModelChange)="onScaleChange($event)"
        />
      </div>
    </div>

    <!-- Rotation (0 - 360°) -->
    <div class="emoji-editor__section">
      <label class="emoji-editor__label">Rotation (°)</label>
      <div class="emoji-editor__scale-row">
        <input
          type="range"
          class="emoji-editor__slider"
          [min]="rotationMin"
          [max]="rotationMax"
          [value]="rotationDeg"
          (input)="onRotationChange(($any($event.target).value))"
        />
        <input
          type="number"
          class="emoji-editor__number"
          [min]="rotationMin"
          [max]="rotationMax"
          [ngModel]="rotationDeg"
          (ngModelChange)="onRotationChange($event)"
        />
      </div>
    </div>
  </div>
  <div class="emoji-editor__footer">
    <button type="button" class="emoji-editor__save-btn" (click)="onSave()">Save Changes</button>
  </div>
</div>
